import { ajax } from '@/plugins/ajax'

export default {
  namespaced: true,
  state: {
    list: [],
    details: [],
    loading: (state) => state.loading

  },
  getters: {
    list: (state) => state.list,
    details: (state) => state.details,
    loading: (state) => state.loading
  },
  actions: {
    fetchSingle({ commit }, id) {
      commit('setLoading', true);
      return new Promise((resolve, reject) => {
        ajax.get('CMS/api/CategoriesQuery/' + id).then(r => {
          commit('setDetails', r.data);
          commit('setLoading', false);
          resolve(r.data)
        }).catch(e => reject(e))
      })
    },
    fetch({ commit, dispatch }) {
      return ajax.get('CMS/api/CategoriesQuery').then(r => {
        commit('setList', r.data.data);
      })
    },
    create({ commit, dispatch }, model) {
      return ajax.post('CMS/api/Categories', model).then(r => {
        dispatch('fetch')
      })
    },
    remove({ commit, dispatch }, id) {
      return ajax.delete('CMS/api/Categories', { data: { "id": id } }, { headers: { 'Content-Type': 'application/json' } }).then(r => {
        dispatch('fetch')
      })
    },
    update({ commit, dispatch }, model) {
      return ajax.put('CMS/api/Categories', model).then(r => {
        dispatch('fetch')
      })
    },
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    },
    setDetails(state, data) {
      state.details = data;
    },
    setLoading(state, value) {
      state.loading = value;
    }
  }
}
